export const experienceData = [
    {
        id: 1,
        company: 'Siemens Digital Logistics',
        jobtitle: 'Junior Software Engineer',
        startYear: '2019',
        endYear: '2022'
    }
]